export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NAVIGATION_NEXT"] = "NAVIGATION_NEXT";
    ACTION["NAVIGATION_CO_BORROWER_PAN"] = "NAVIGATION_CO_BORROWER_PAN";
})(ACTION || (ACTION = {}));
